const sortTypes = {
    ASC: DjangIO.app.userdata.spreadsheet.types.SheetSortType.ascending.value,
    DESC: DjangIO.app.userdata.spreadsheet.types.SheetSortType.descending.value,
}

export const reverseSortDirection = (sortType = sortTypes.ASC) => (
    sortType === sortTypes.DESC
        ? sortTypes.ASC
        : sortTypes.DESC
)

export default sortTypes
